var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-between flex-wrap"},[_c('div',{staticClass:"col-xs-12 col-md-3 pr-sm-3"},[_c('talent-info-card')],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-9 p-0 pl-sm-3"},[_c('search-results-card')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ab93b8e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/talentSearch/general.vue
// module id = null
// module chunks = 